export default __webpack_public_path__ + "static/media/saas.4e03f0f1.jpg";